import { Component, OnInit, ViewChild } from '@angular/core';
import { EditorComponent } from '../../../base/editor/editor.component';
import { HistoryComponent } from '../../../fragments/history/history.component';
import { ChipSelectorComponent } from '../../../fragments/chip-selector/chip-selector.component';
import { AppService } from '../../../../services/app.service';
import { TextMessageService } from '../../../../services/text-messages/text-message.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TextMessageEnvelope } from '../../../../models/net/envelope/text-message-envelope';
import { AvatarPrimitive } from '../../../../models/app/avatar-primitive';
import { TextMessageDocument } from '../../../../models/net/envelope/documents/text-message-document';

@Component({
    selector: 'app-text-message',
    templateUrl: './text-message.component.html',
    styleUrls: ['./text-message.component.css', '../../../../app.component.css']
})

export class TextMessageComponent extends EditorComponent {

    public messageBody: string = "";
    public availablePhoneNumbers: AvatarPrimitive[] = [];
    public selectedToPhoneNumbers: number[] = [];
    public ccBccDivDynamicClassName: string = "expanding-div-collapsed";
    public ccBccToggleButtonDynamicIconName: string = "keyboard_double_arrow_down";
    public gatewayProviderProviderTypes: { GatewayProviderProviderTypeId: number, GatewayProviderName: string }[] = [];

    @ViewChild("appHistory") appHistory!: HistoryComponent;
    @ViewChild("toPhoneNumbersChipSelector") toPhoneNumbersChipSelector!: ChipSelectorComponent;

    public constructor(public override appService: AppService,
                       public override itemService: TextMessageService,
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "textmessage", "textmessages");
    }

    public override initializeEnvelope = (envelope: TextMessageEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new TextMessageEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);

        if (this.itemEnvelope?.Document.Item.Body === null || this.itemEnvelope?.Document.Item.Body === undefined) {

            this.itemEnvelope!.Document.Item.Body = "";
        }

        this.gatewayProviderProviderTypes = (this.itemEnvelope as TextMessageEnvelope).GatewayProviderProviderTypes.filter(gppt => gppt.ProviderTypeId === 1).map(gppt => {

            const provider = (this.itemEnvelope as TextMessageEnvelope).GatewayProvidersPool.find(gp => gp.GatewayProviderId === gppt.GatewayProviderId);

            return {
                GatewayProviderProviderTypeId: gppt.GatewayProviderProviderTypeId,
                GatewayProviderName: provider ? provider.UID : "(unknown)"
            };
        });
    }

    public ngAfterViewInit(): void {

        this.toPhoneNumbersChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {
            //this.addRecipientToTextMessage(item.Name);
        });
    }
}
